import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import viewMixin from '../../../components/core/consumers/viewMixin';
import ApiService from '../../../services/apiService';
import { userItemsPerListMixin } from '../../../utils/vuex';
import cloneDeep from 'lodash/cloneDeep';
import { mapState, mapGetters } from 'vuex';
var emptyModel = {
  filter: {
    type: 'wizard',
    contentTypes: {}
  },
  properties: {}
};
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
var EDITOR_DEFAULTS = {
  jsonata: '$.value = 42',
  javascript: 'return x.value == 42'
};
export default {
  name: 'ViewConnectorsConsumersFilters',
  mixins: [viewMixin, userItemsPerListMixin],
  data: function data() {
    return {
      searchItem: '',
      deleteItemId: null,
      deletePrompt: false,
      accounts: [],
      filterTypes: ['jsonata', 'javascript'],
      filterModel: cloneDeep(emptyModel),
      filterExtended: false,
      filterRows: [],
      selectedAccount: null,
      selectedAccounts: [],
      loadingAccounts: true,
      isCreateDialog: true,
      tableOptions: defaultTableOptions
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('authentication', ['tenantId'])), mapGetters({
    isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
  })), {}, {
    inputTypes: function inputTypes() {
      switch (this.filterModel.filter.type) {
        default:
          return ['application/json', 'text/plain', 'generic'];
      }
    },
    attributesSelect: function attributesSelect() {
      return [// {
      //   text: this.$i18n_t('Consumers.Filter.createDialog.attributes.accountId'),
      //   value: 'account_id',
      // },
      {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.configId'),
        value: 'config_id'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.stateId'),
        value: 'state_id'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.dtwinId'),
        value: 'dtwin_id'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.dtwinTitle'),
        value: 'dtwin_title'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.unit'),
        value: 'unit'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.stateIdentifier'),
        value: 'state_identifier'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.stateTtype'),
        value: 'state_type'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.sourceType'),
        value: 'source_type'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.parserVariable'),
        value: 'parser_variable'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.sourceIdentifier'),
        value: 'source_identifier'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.timestamp'),
        value: 'timestamp'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.twin_category'),
        value: 'twin_category'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.geolocation'),
        value: 'geolocation'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.vdevice_groups'),
        value: 'vdevice_groups'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.twin_tags'),
        value: 'twin_tags'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.twin_key_value'),
        value: 'twin_key_value'
      }].concat(_toConsumableArray(this.isFeatureFlagEnabled('env_dispatcher_devicetype_fallback') === false ? [{
        text: this.$i18n_t('Consumers.Filter.createDialog.attributes.device_driver_id'),
        value: 'device_driver_id'
      }] : []));
    },
    operatorSelect: function operatorSelect() {
      return [{
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.equals'),
        value: 'EQUALS'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.notEquals'),
        value: 'NOT_EQUALS'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.greaterThan'),
        value: 'GREATER_THAN'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.lessThan'),
        value: 'LESS_THAN'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.contains'),
        value: 'CONTAINS'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.notContains'),
        value: 'NOT_CONTAINS'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.isNull'),
        value: 'IS_NULL'
      }, {
        text: this.$i18n_t('Consumers.Filter.createDialog.operators.isNotNull'),
        value: 'IS_NOT_NULL'
      }];
    },
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('Connectors.Filter.table.id'),
          value: 'id',
          align: 'center'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.name'),
          value: 'name',
          align: 'start'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.type'),
          sortable: true,
          value: 'filter.type',
          align: 'start'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.inputType'),
          sortable: true,
          value: 'filter.inputType'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.account'),
          value: 'tenantId'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.createdAt'),
          value: 'createdAt'
        }, {
          value: 'actions'
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, 20, 50]
        }
      };
    }
  }),
  watch: {
    selectedAccounts: function selectedAccounts() {
      this.fetchFilters(this.selectedAccounts);
    },
    inputTypes: function inputTypes() {
      if (this.inputTypes.length === 1) {
        this.filterModel.filter.inputType = this.inputTypes[0];
      }
    },
    'filterModel.filter.type': function filterModelFilterType() {
      if (!this.filterModel.id || typeof this.filterModel.filter.definition !== 'string') {
        // Only set defaults if it's a new filter or the definition is not a string.
        this.setEditorDefaults();
      }
    }
  },
  created: function created() {
    this.fetchAccounts();
  },
  mounted: function mounted() {
    this.setupFilterRows();
  },
  methods: {
    switchExtended: function switchExtended() {
      if (this.filterExtended && this.filterModel.filter.type === 'wizard') {
        this.filterModel.filter.type = 'jsonata';
      }
    },
    setEditorDefaults: function setEditorDefaults() {
      if (!EDITOR_DEFAULTS[this.filterModel.filter.type]) {
        this.filterModel.filter.definition = EDITOR_DEFAULTS.jsonata;
        console.warn("Unexpected filter type: ".concat(this.filterModel.filter.type));
      } else {
        this.filterModel.filter.definition = EDITOR_DEFAULTS[this.filterModel.filter.type];
      }
    },
    setupFilterRows: function setupFilterRows() {
      this.filterRows = [].concat(_toConsumableArray(this.filterRows), [{}]);
    },
    sanitizeFilterRows: function sanitizeFilterRows() {
      // remove any entries that are missing at least one field
      this.filterRows = this.filterRows.filter(function (row) {
        return row.attribute && row.operator && row.values;
      });
      this.filterRows.push({});
    },
    removeFilterRow: function removeFilterRow(index) {
      this.filterRows.splice(index, 1);
    },
    addFilterRow: function addFilterRow(index) {
      this.filterRows.splice(index + 1, 0, {});
    },
    openEditModal: function openEditModal() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (item === null) {
        this.isCreateDialog = true;
        this.filterModel = cloneDeep(emptyModel);
        this.selectedAccount = null;
        this.filterExtended = false;
        this.filterRows = [{}];
      } else {
        this.isCreateDialog = false;
        this.filterModel = cloneDeep(item || emptyModel);
        this.selectedAccount = this.accounts.find(function (acc) {
          return acc.id === item.tenantId;
        });
        this.filterExtended = this.filterModel.filter.type !== 'wizard';
        this.filterRows = (!this.filterExtended ? this.filterModel.filter.definition : null) || [{}];
      }

      this.formDialogOpen = true;
    },
    save: function save() {
      var _this = this;

      var promise = null;
      var model = cloneDeep(this.filterModel);

      if (!this.filterExtended) {
        // Wizard view was active when saving so we save only the wizard data
        model.filter = {
          type: 'wizard',
          contentTypes: {},
          definition: this.filterRows,
          inputType: 'generic'
        };
      }

      if (this.filterModel.id) {
        promise = ApiService.consumerFiltersUpdate(this.filterModel.id, model);
      } else {
        promise = ApiService.consumerFiltersCreate(this.selectedAccount, model);
      }

      promise.then(function () {
        _this.fetchFilters();

        _this.closeDialog();
      }).catch(function (e) {
        _this.$snack(e.response.data.message, 'error');
      });
    },
    showDeletePrompt: function showDeletePrompt(id) {
      this.deleteItemId = id;
      this.deletePrompt = true;
    },
    deleteFilter: function deleteFilter(id) {
      var _this2 = this;

      ApiService.consumerFiltersDelete(id).then(function () {
        _this2.fetchFilters(_this2.selectedAccounts);
      }).catch(function (e) {
        _this2.$snack(e.response.data.message, 'error');
      }).finally(function () {
        _this2.deletePrompt = false;
      });
    },
    fetchAccounts: function fetchAccounts() {
      var _this3 = this;

      this.$store.dispatch('app/loadAccounts').then(function (accounts) {
        _this3.accounts = accounts;
      }).catch(function (error) {
        console.error(error);

        _this3.$snack(_this3.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
      });
    }
  }
};